export const l = console.log;